
import React, {Component} from "react";
import style from "./style.scss";
import {Avatar, Badge} from "antd";

export class InfoCard extends Component {


    render() {
        return (
            <div className={style.infoCard}>

    <div className={style.cardBody}>
        {this.props.icon !== null ? (
            <div className={style.leftIcon}>
            {this.props.icon}
        </div>
        ) : null}
    <div className={style.content}>
    <div className={style.value}>
        {this.props.value}
    </div>
        <div className={style.title}>
        {this.props.title}
    </div>
        </div>




        {this.props.icon !== null ? (
            <div className={style.bgIcon}>
            {this.props.icon}
        </div>
        ) : null}
    </div>
        </div>
    )
    }
}


export class UserContactCardMini extends Component {

    render() {
        return (
            <div className={style.userContactCardMini}>
                <Avatar size={32} src={this.props.src}/>
                <div className={style.content}>
                    <div className={style.userName}>{this.props.name}</div>
                    <div className={style.userInfo}>{this.props.info}</div>
                </div>
                {this.props.online?( <Badge status="success" />):(<Badge status="processing" />)}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Theme/Cards/index.js